import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
/* eslint-disable no-use-before-define */import { useCallback, useRef, useState, useEffect } from 'react';
import { useCallbackRef } from './useCallbackRef';
function useControllable(_ref) {
  var prop = _ref.prop,
    defaultProp = _ref.defaultProp,
    onChange = _ref.onChange;
  var _useUncontrolled = useUncontrolled({
      defaultProp: defaultProp,
      onChange: onChange
    }),
    _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
    uncontrolledProp = _useUncontrolled2[0],
    setUncontrolledProp = _useUncontrolled2[1];
  var isControlled = prop !== undefined;
  var value = isControlled ? prop : uncontrolledProp;
  // $FlowFixMe[incompatible-call]
  var handleChange = useCallbackRef(onChange);
  var setValue = useCallback(function (nextValue) {
    if (isControlled) {
      var computedValue =
      // $FlowFixMe[incompatible-use]
      // $FlowFixMe[incompatible-call]
      typeof nextValue === 'function' ? nextValue(prop) : nextValue;
      if (computedValue !== prop) {
        handleChange(computedValue);
      }
    } else {
      setUncontrolledProp(nextValue);
    }
  }, [isControlled, prop, handleChange, setUncontrolledProp]);

  // $FlowFixMe[incompatible-return]
  return [value, setValue];
}
function useUncontrolled(_ref2) {
  var defaultProp = _ref2.defaultProp,
    onChange = _ref2.onChange;
  var uncontrolledState = useState(defaultProp);
  var _uncontrolledState = _slicedToArray(uncontrolledState, 1),
    value = _uncontrolledState[0];
  var prevValueRef = useRef(value);
  // $FlowFixMe[incompatible-call]
  var handleChange = useCallbackRef(onChange);
  useEffect(function () {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef, handleChange]);

  // $FlowFixMe[incompatible-return]
  return uncontrolledState;
}
export { useControllable };